import moment from "moment";
import "./MapStyle.css";
import useFavorites from "../../../utils/useFavorites";
import { useDispatch, useSelector } from "react-redux";
import { fetchSingleProgram } from "../../../redux/actions/immobilierActions";
import { imageLoader } from "../../../utils/imageLoader";
import { useRef, useEffect } from "react";
import ProgramCardSkeleton from "./ProgramCardSkeleton";

const ProgramCard = ({
  listeDesProgrammes,
  selectedProgram,
  setSelectedProgram,
  itineraryRef,
}) => {
  const dispatch = useDispatch();
  const { isProgramInFavorites, handleAddToFavorites } = useFavorites();
  const { deepSearchLoading } = useSelector((state) => state.immobilierReducer);
  const programRefs = useRef({});

  // Helper function to get programme image URL with priority
  const getProgrammeImageUrl = (programme) => {
    // Check programme images first
    if (programme.images?.[0]?.image?.[0]?.url) {
      return imageLoader(programme.images[0].image[0].url);
    }

    // Find first lot with an image
    const lotWithImage = programme.lots?.find(
      (lot) => lot.images?.[0]?.image?.[0]?.url,
    );
    if (lotWithImage?.images?.[0]?.image?.[0]?.url) {
      return imageLoader(lotWithImage.images[0].image[0].url);
    }

    // Check promoteur logo
    if (programme.promoteur?.logo?.url) {
      return imageLoader(programme.promoteur.logo.url);
    }

    // Final fallback
    return "./assets/imgNotFound.webp";
  };

  const handleProgramDoubleClick = (programId) => {
    dispatch(fetchSingleProgram(programId));
  };

  useEffect(() => {
    if (selectedProgram && programRefs.current[selectedProgram.documentId]) {
      programRefs.current[selectedProgram.documentId].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [selectedProgram]);

  return (
    <div className="d-flex flex-wrap gap20 w100">
      <div className="w100" ref={itineraryRef}></div>
      {deepSearchLoading ? (
        <ProgramCardSkeleton />
      ) : !listeDesProgrammes || listeDesProgrammes.length === 0 ? (
        <div className="w100 text-center p-5 bg-white radius5">
          <p className="fs21 semibold darkGrey mb-3">
            Aucun programme disponible
          </p>
          <p className="fs16 regular darkGrey">
            Aucun programme immobilier n'est disponible dans cette localisation.
          </p>
        </div>
      ) : (
        listeDesProgrammes.map((programme) => (
          <div
            key={programme.documentId}
            ref={(el) => (programRefs.current[programme.documentId] = el)}
            className={`programCard d-flex w100 bg-white radius5 gap20 p-2 pointer ${
              selectedProgram?.documentId === programme.documentId
                ? "selected"
                : ""
            }`}
            onClick={() => {
              // If clicking the same program, toggle off then on to force InfoWindow reopen
              if (selectedProgram?.documentId === programme.documentId) {
                setSelectedProgram(null);
                setTimeout(() => setSelectedProgram(programme), 0);
              } else {
                setSelectedProgram(programme);
              }
            }}
            onDoubleClick={() => handleProgramDoubleClick(programme.documentId)}
          >
            <img
              src={getProgrammeImageUrl(programme)}
              alt="appart"
              className="radius5 w40"
            />

            <div
              className="w100 d-flex flex-column justify-content-between"
              // style={{
              //   overflow: "hidden",
              //   textOverflow: "ellipsis",
              //   whiteSpace: "nowrap",
              // }}
            >
              <div>
                <div className="d-flex justify-content-between">
                  <div className="d-flex flex-column gap10 ">
                    <p className="semibold fs21 darkGrey">{programme.name}</p>
                    <p className="darkGrey fs16 regular">
                      {programme.promoteur?.name || "NC"}
                    </p>
                    <p className="darkGrey fs16 semibold">
                      {programme.address || "Municipalité"}
                    </p>
                  </div>
                  <div className="d-flex flex-column text-end ">
                    <p className="darkGrey fs11 regular">
                      TVA {programme.TVA || "NC"}
                    </p>
                    <div className="darkGrey fs18 semibold mb-10">
                      <p className="fs11 regular"> à partir de</p>
                      {Intl.NumberFormat("fr-FR").format(
                        programme?.lots[0]?.price_total,
                      ) + "€" || "NC"}
                    </div>
                    <p className="darkGrey fs11 regular">
                      Hono. {programme.honoraires || "NC"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="separator my-2"></div>

              <div className="d-flex justify-content-between ">
                <div className=" d-flex gap10 flex-wrap align-items-center">
                  <img
                    src={
                      isProgramInFavorites(programme.documentId)
                        ? "./icons/favorite-filled.svg"
                        : "./icons/favorite-outline.svg"
                    }
                    alt="favorite"
                    height={35}
                    width={35}
                    className=""
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAddToFavorites(programme.documentId, "Programme");
                    }}
                  />
                </div>
                <div className="d-flex  gap-3 ">
                  <div>
                    <p className="darkGrey fs11 regular">Actabilité :</p>
                    <p className="darkGrey fs16 semibold mb-20">
                      {programme.is_actable ? "Immédiate" : "Pas Précisé"}
                    </p>
                  </div>
                  <div>
                    {" "}
                    <p className="darkGrey fs11 regular">Livraison :</p>
                    <p className="darkGrey fs16 semibold">
                      {programme.delivery_date
                        ? moment(programme.delivery_date).format("YYYY") +
                          " T-" +
                          moment(programme.delivery_date).quarter()
                        : "NC"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ProgramCard;
